import { c as _c } from "react/compiler-runtime";
import { PaperClipIcon } from '@heroicons/react/24/solid';
import type React from 'react';
import { cn } from '../../../../../shared/cn';
import { Link } from '../../../../actions/Link';
import type { AttachmentFile } from './types';
export const ViewAttachments: React.FC<{
  files: AttachmentFile[];
}> = t0 => {
  const $ = _c(4);
  const {
    files
  } = t0;
  console.log("ViewAttachments");
  if (files.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== files) {
    t1 = files.map(_temp);
    $[0] = files;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="flex flex-col gap-2">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
function _temp(file) {
  return <Link key={file.key} href={file.ufsUrl} target="_blank" rel="noopener noreferrer" className={cn("flex w-fit flex-row items-center gap-2 text-contentNavyAlgo")}><PaperClipIcon className="h-4 w-4" />{file.name}</Link>;
}